import React,{useState,useEffect,useRef} from 'react'
import {Form,Row,Col} from 'react-bootstrap'
import {TextInput} from "../demographics/dropdowns/components"
import clearParentState from "../../utilities/ClearParentState/clearstate"

function YesNoDrop(props){
    const [value,setVal] = useState(props.val!=null?props.val[props.name]:"")
    const [disabled,setDisabled] = useState(props.disabled)
    const [secValue,setSecValue] = useState("")
    const[disabledSec,setDisabledSec] =useState(true)
    const handleChange = (event) =>{
        setVal(event.target.value)
        if(event.target.value == "Yes"){
            setDisabledSec(false)
        }
        else{
            setDisabledSec(true)
            setSecValue("")
            props.clean("bmri",props.secondName)
        }
        props.handler(event)
    }
    const handleSecond = (event) =>{
        setSecValue(event.target.value)
       
        props.handler(event)
    }
    useEffect(()=>{
        setDisabled(props.disabled)
        if (props.val === null){
            return null
        }
        if (props.val[props.name] =="Yes" && !props.disabled){
            setDisabledSec(false)
        }
    },[props.disabled])
    useEffect(()=>{
        if(props.val!=null){
            setVal(props.val[props.name])
            setSecValue(props.val[props.secondName])
            if (props.val[props.name] =="Yes" && !props.disabled){
                setDisabledSec(false)
            }
            else{
                setDisabledSec(true)
            }
        }
    },[props.val])
    useEffect(()=>{
        if(value === 'No' &&props.val==null && props.second_type=='date' ){
            let clear = clearParentState(props.name+'_when')
            props.handler(clear)
        }
    },[value])
    
    return(
        <>
            <Form.Group as={Col}>
                <Form.Label>{props.title}</Form.Label>
                <Form.Control as={"select"} name={props.name}  onChange={handleChange} value={value} disabled={disabled}>

                    <option></option>
                    <option>Yes</option>
                    <option>No</option>
                    

                </Form.Control>
            </Form.Group>
            {props.second_type=="date"&& 
            <Form.Group as={Col}> 
                    <Form.Label>{props.second_title}</Form.Label>
                    <Form.Control type={'date'} disabled={disabledSec} onChange={handleSecond} value={secValue} name={props.secondName}/>
            </Form.Group>}
            {props.second_type=="select"&& 
            <Form.Group as={Col}> 
                    <Form.Label>{props.second_title}</Form.Label>
                    <Form.Control as={"select"} disabled={disabledSec} onChange={handleSecond} value={secValue} name={props.secondName}>
                        <option></option>
                        {props.secondAnswers.map((a,i)=>(
                            <option key={i}>{a}</option>
                        ))}
                    </Form.Control>
                    
            </Form.Group>}

        </>
    )
}
function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value; //assign the value of ref to the argument
    },[value]); //this code will run when the value of 'value' changes
    return ref.current; //in the end, return the current ref value.
  }
function YesNo(props){
    const [value,setValue] = useState("")
    const [disabled,setDis] = useState(props.disabled)
    const prevStatus = usePrevious(props.disabled)
    useEffect(()=>{
        
        if(props.data!=null){
            setValue(props.data[props.name])
            // if (props.disabled == true){
            //     setDis(true)
            // }
            // else{
            //     setDis(false)
            // }
           
        }
       

       
        setDis(props.disabled)
       
    },[props.data,props.disabled])
   
    const handleChange = (e) =>{
        setValue(e.target.value)
        props.handler(e)
    }
    return(
        <Form.Group as={Col}>
            <Form.Label>{props.title}</Form.Label>
            <Form.Control as={"select"} value={value} onChange={handleChange}name={props.name} disabled={disabled}>
                    <option></option>
                    <option> Yes</option>
                    <option> No</option>
            </Form.Control>
            
        </Form.Group>
    )
}
YesNoDrop.defaultProps = { 
    name:"",
    title:"",
    secondAnswers:[],
    second_type:"",
    second_title:"",
    secondName:""
}

class Brain_Magnetic_Resonance_Imaging extends React.Component{
    constructor(props){
        super(props)
        this.state={
            midbrainSubDisabled:true,
            mountedOnEdit:false,
            data:{
                midbrain_atrophy:"",
                midbrain_area:"",
                midbrain_pons_area_ratio:"",
                mrpi:"",
                frontal_atrophy_addition_midbrain_atrophy:"",
                superior_cerebellar_peduncle_atrophy:"",
                middle_cerebellar_peduncle_atrophy:"",
                pons_atrophy:"",
                putaminal_rim:"",
                hot_cross_bun_sign:"",
                frontal_atrophy:"",
                other:""


            }
        }
    }
     check = this.props.check // check function see parent
    
     
    handleChange = (event)=>{
        
        
        // event.persist()
        this.setState((prevState)=>({
            ...prevState,
            data:{
                ...prevState.data,
                [event.target.name] : event.target.value
            }
        }))
        if(event.target.name == "midbrain_atrophy" && event.target.value == "No"){
            this.cleanParentState()
        }
        
        this.props.handler('bmri',event)
    }
    cleanParentState = () =>{
        let data = {
           
            midbrain_area:"",
            midbrain_pons_area_ratio:"",
            mrpi:"",
           

        }
        this.props.clean('bmri',data)
        this.setState({data:data})
    }
    handleChangemidBrain = (event) =>{
        if(event.target.value =="Yes"){
            this.setState({midbrainSubDisabled:false})
        }
        else{
            this.setState({midbrainSubDisabled:true})
        }
        this.handleChange(event)
        
    }
    
   
   async componentDidMount(){
        if(this.props.data!=null){
           await this.setState({data:this.props.data})
           if(this.props.data["midbrain_atrophy"]=='Yes' && !this.props.disabled){
               this.setState({midbrainSubDisabled:false})
           }
        }
    } 
    componentDidUpdate(prevProps){
        if (prevProps.disabled!=this.props.disabled){
            if (this.props.data!=null){
                if(this.props.data['midbrain_atrophy'] == 'Yes'){
                    this.setState({midbrainSubDisabled:false})
                }
            }
        }
    }
    render(){
    
    return(
        
            <Form>
            
                <Form.Row>
                <YesNoDrop title="Brain Magnetic Resonance Imaging" 
                name="bmri" 
                second_type={'date'}
                second_title={"When"}
                secondName={"bmri_when"} 
                val={this.props.data!=null? this.props.data:null} 
                disabled ={this.props.disabled}  
                handler={this.handleChange}
                clean={this.props.clean}
                />      
                {/* <Form.Group as={Col}> 
                    <Form.Label>When</Form.Label>
                    <Form.Control type={'date'} disabled={this.check("bmri","bmri")?false:true}/>
                </Form.Group> */}
                </Form.Row>
                <Form.Row>
                    <YesNoDrop
                    title= "Structural abnormalities " 
                    name="stractural_abnormalities"
                    second_title={"Select"}
                    secondName={"stractural_abnomarlities_type"} 
                    second_type={"select"}
                    secondAnswers={["Microvascular changes","Tumor","Dilatation of ventricles", "Previous stroke","Other"]}
                    clean={this.props.clean}
                    val={this.props.data!=null? this.props.data:null} 
                    disabled ={this.props.disabled } 
                    handler={this.handleChange}/>
                    <Form.Group as={Col}>
                        <Form.Label>If other please specify</Form.Label>
                        <Form.Control type={"text"} onChange={this.handleChange} name={"stractural_abnomarlities_type_other"} 
                        disabled={this.props.disabled!=undefined?this.props.disabled:this.props.checkforKeyword("bmri","stractural_abnomarlities_type",'Other')} value={this.props.data!=null ?this.props.data["stractural_abnomarlities_type_other"]:this.state.stractural_abnomarlities_type_other} />
                        
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <h5>Measures</h5>
                </Form.Row>
                <Form.Row>
                <Form.Group as={Col}>
                        <Form.Label>Midbrain atrophy</Form.Label>
                        <Form.Control as={"select"}  onChange={this.handleChangemidBrain} disabled ={this.props.disabled} value={this.props.data!=null ?this.props.data["midbrain_atrophy"]:this.state.midbrain_atrophy} name={"midbrain_atrophy"}>
                            <option></option>
                            <option>Yes</option>
                            <option>No</option>
                        </Form.Control>
                </Form.Group>
                <Col>
                <Form.Group as={Col}>
                        <Form.Label>Midbrain Area</Form.Label>
                        <Form.Control type={"text"} name={"midbrain_area"} onChange={this.handleChange} value={this.props.data!= null ? this.props.data["midbrain_area"]: this.state.data.midbrain_area} disabled={this.state.midbrainSubDisabled}  />
                            
                </Form.Group>
                <Form.Group as={Col}>
                        <Form.Label>Midbrain-pons area ratio</Form.Label>
                        <Form.Control type={"text"} name={"midbrain_pons_area_ratio"}  value={this.props.data!=null?this.props.data["midbrain_pons_area_ratio"]:this.state.data.midbrain_pons_area_ratio} onChange={this.handleChange} disabled={this.state.midbrainSubDisabled}  />
                            
                </Form.Group>
                <Form.Group as={Col}>
                        <Form.Label>MRPI</Form.Label>
                        <Form.Control type={"text"} name={"mrpi"} value={this.props.data!=null?this.props.data["mrpi"]:this.state.data.mrpi} onChange={this.handleChange} disabled={this.state.midbrainSubDisabled}  />
                            
                </Form.Group> 
                </Col>             
                </Form.Row>
                <Form.Row>
                    <YesNo title="Frontal atrophy in addition to midbrain atrophy" disabled ={this.props.disabled}  data={this.props.data} name="frontal_atrophy_addition_midbrain_atrophy" handler={this.handleChange}/>
                    <YesNo title="Superior cerebellar peduncle atrophy" name="superior_cerebellar_peduncle_atrophy"  disabled ={this.props.disabled}  data={this.props.data}handler={this.handleChange}/>
                </Form.Row>
                <Form.Row>
                    <YesNo title="Middle cerebellar peduncle atrophy" name="middle_cerebellar_peduncle_atrophy"  disabled ={this.props.disabled} data={this.props.data} handler={this.handleChange}/>
                    <YesNo title="Putaminal Rim" name="putaminal_rim" disabled ={this.props.disabled}  data={this.props.data} handler={this.handleChange}/>
                </Form.Row>
                <Form.Row>
                    <YesNo title="Pons atrophy" name="pons_atrophy"  disabled ={this.props.disabled}  data={this.props.data} handler={this.handleChange}/>
                    <YesNo title="Hot cross bun sign" name="hot_cross_bun_sign"data={this.props.data}  disabled ={this.props.disabled}  handler={this.handleChange}/>
                </Form.Row>
                <Form.Row>
                    <YesNo title="Frontal atrophy" name="frontal_atrophy" disabled ={this.props.disabled}  data={this.props.data}handler={this.handleChange}/>
                    <YesNo title="Other" name="other"data={this.props.data} disabled ={this.props.disabled}   handler={this.handleChange}/>
                    
                </Form.Row>

                
            </Form>)
        }
}

export default Brain_Magnetic_Resonance_Imaging;